import { sms } from '@axo/shared/data-access/types';
import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';

export function createSMS({ url: { service: baseURL }, token }: IAPI) {
  return (sms: sms.CreateSMS): Promise<sms.SMS> =>
    send({
      baseURL,
      token,
      path: `/sms-communication`,
      method: 'POST',
      body: sms,
    });
}

export interface SMS {
  Items: sms.SMS[];
}

export function findSMS({ url: { service: baseURL }, token }: IAPI) {
  return (input: sms.SMSFindInput): Promise<SMS> => {
    const queryParams = Object.entries(input)
      .filter(([, value]) => value !== undefined && value !== null)
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join('&');

    return send({
      baseURL,
      token,
      path: `/sms-communication?${queryParams}`,
      method: 'GET',
    });
  };
}

export function getSMS({ url: { service: baseURL }, token }: IAPI) {
  return (SMSID: string | undefined): Promise<sms.SMS> =>
    send({
      baseURL,
      token,
      path: `/sms-communication/${SMSID}`,
      method: 'GET',
    });
}

export function patchSMS({ url: { service: baseURL }, token }: IAPI) {
  return async (
    patch: Pick<sms.SMS, 'ID' | 'FollowupAt' | 'ResolvedAt'>
  ): Promise<sms.SMS> =>
    send({
      baseURL,
      token,
      path: `/sms-communication/${patch.ID}`,
      method: 'PATCH',
      body: patch,
    });
}
